var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/**
 * @ComponentFor EPiServer.SpecializedProperties.LinkItemCollection
 */
import * as React from 'react';
import { Link } from '@avensia/nitro5-scope';
export default (props) => (React.createElement("ul", null, props.links.map((link, i) => {
    const { href, text } = link, linkProps = __rest(link, ["href", "text"]);
    return (React.createElement("li", { key: i },
        React.createElement(Link, Object.assign({}, linkProps, { to: href }), text)));
})));
